import { useQuery as c } from "@tanstack/react-query";
import { a as o } from "./api.DHdhNbok.js";
import { saveTimestampToLocalStorage as s } from "../utils/storage/index.js";
import { S as i, q as p } from "./stale.constant.De1PuSBj.js";
const n = {
  getUser: "api/accounts",
  updateUser: "api/accounts",
  accountRelationTypes: "api/accounts/relation-types",
  accountRelationships: "api/accounts/relationships",
  getEmploymentStatuses: "api/accounts/employment/employment-statuses",
  deleteEmployment: "api/accounts/employment/delete-employment",
  allStatesList: "api/accounts/states"
}, u = async (t) => {
  s();
  const e = new URLSearchParams(t).toString(), a = await o.get(`${n.getUser}?${e}`);
  if (!a.ok)
    throw new Error(await a.json());
  return a.json();
}, d = async (t) => {
  s();
  const e = await o.put(`${n.updateUser}`, t);
  if (!e.ok)
    throw new Error(await e.json());
  return e.json();
}, h = async () => {
  s();
  const t = await o.get(n.accountRelationTypes);
  if (!t.ok)
    throw new Error(await t.json());
  return t.json();
}, j = async (t) => {
  s();
  const e = await o.post(n.accountRelationships, t);
  if (!e.ok)
    throw new Error(await e.json());
  return e.json();
}, E = async (t) => {
  s();
  const e = await o.put(
    `/${n.accountRelationships}?id=${t.mhoId}`,
    t.payload
  );
  if (!e.ok)
    throw new Error(await e.json());
  return e.json();
}, R = async (t) => {
  s();
  const e = await o.delete(`${n.accountRelationships}/${t}`);
  if (!e.ok)
    throw new Error(await e.json());
  return e.json();
}, g = async () => {
  s();
  const t = await o.get(`${n.getEmploymentStatuses}`);
  if (!t.ok)
    throw new Error(await t.json());
  return t.json();
}, f = async (t) => {
  s();
  const { connectedRelUsername: e } = t, a = e ? `?connectedRelUsername=${encodeURIComponent(e)}` : "", r = await o.delete(`${n.deleteEmployment}${a}`);
  if (!r.ok)
    throw new Error(await r.json());
  return r.json();
}, S = async () => {
  s();
  const t = await o.get(`${n.allStatesList}`);
  if (!t.ok)
    throw new Error(await t.json());
  return t.json();
}, $ = ({
  queryParams: t,
  enabled: e = !0,
  refetchOnMount: a
}) => c({
  queryKey: p.user(t.levelOfDetail, t.connectedRelUsername),
  queryFn: () => u(t),
  staleTime: i,
  refetchOnMount: a,
  enabled: e,
  select: (r) => r.data
});
export {
  S as a,
  d as b,
  $ as c,
  j as d,
  R as e,
  g as f,
  h as g,
  f as h,
  E as u
};
